
export const AUTOPAY_CONSENT = {
  authorization: 'constantsAutopayConsentAuthorization',

  amountDisclaimer: 'paymentsAutopayReviewAmountDisclaimer',

  biweeklyAdditionalPrincipal: 'constantsAutopayConsentBiweeklyAdditionalPrincipal',
} as const;

export const ONE_TIME_PAYMENT_CONSENT = {
  authorization: 'constantsOneTimePaymentConsentAuthorization',

  confirmationQuestion: 'constantsOneTimePaymentConsentConfirmationQuestion',

  processingDisclaimer: 'constantsPaymentInfoProcessingTime',
} as const;

export const BANK_ACCOUNT_CONSENT = {
  addAccount: 'constantsBankAccountConsentAddAccount',

  deleteWithPendingPayments: 'constantsBankAccountConsentDeleteWithPendingPayments',
} as const;

export const EMAIL_NOTIFICATION_CONSENT = {
  emailSentPreText: 'constantsEmailNotificationConsentEmailSentPreText',

  emailSentPostText: 'constantsEmailNotificationConsentEmailSentPostText',

  mailNotification: 'constantsEmailNotificationConsentMailNotification',
} as const;

export const TCPA_CONSENT = {
  stayConnected: 'consentTcpaConsentLegalText',

  dialogTitle: 'consentTcpaConsentDialogTitle',

  disclosure: 'constantsTcpaConsentDisclosure',

  declineWarningTitle: 'constantsTcpaConsentDeclineWarningTitle',

  declineWarningMessage: 'constantsTcpaConsentDeclineWarningMessage',
} as const;

export const ELECTRONIC_COMMUNICATIONS_CONSENT = {
  goPaperless: 'constantsElectronicCommunicationsConsentGoPaperless',
} as const;

export const HELOC_DRAW_CONSENT = {
  authorization: 'helocDrawAuthorizationText',
} as const;

export const AUTOPAY_CONSENT_FLOW = {
  confirmInfo: 'consentAutopayConsentConsentInfo',
} as const;

export const E_CONSENT = {
  withdrawWarning: 'constantsEConsentWithdrawWarning',

  withdrawConfirmation: 'constantsEConsentWithdrawConfirmation',
} as const;

export const INSURANCE_TRANSITION = {
  geicoName: 'constantsInsuranceTransitionGeicoName',

  melloName: 'constantsInsuranceTransitionMelloName',

  geicoDescription: 'constantsInsuranceTransitionGeicoDescription',

  melloDescription: 'constantsInsuranceTransitionMelloDescription',

  redirectNotice: 'constantsInsuranceTransitionRedirectNotice',

  continueButton: 'constantsInsuranceTransitionContinueButton',
} as const;

export const CREDIT_CARD_PAYMENT = {
  title: 'constantsCreditCardPaymentTitle',

  processingMessage: 'commonMessagesProcessingPayment',

  successMessage: 'constantsCreditCardPaymentSuccessMessage',

  errorMessage: 'constantsCreditCardPaymentErrorMessage',

  reviewTitle: 'paymentReviewTitle',

  pciDisclaimer: 'constantsCreditCardPaymentPciDisclaimer',
} as const;

export const CONGRATULATIONS = {
  title: 'commonLabelsCongratulations',

  allTodosComplete: 'constantsCongratulationsAllTodosComplete',

  loanApproved: 'constantsCongratulationsLoanApproved',

  continueButton: 'commonButtonsContinue',
} as const;

export const VERIFY_BORROWER = {
  title: 'commonMessagesVerifyIdentity',

  description: 'constantsVerifyBorrowerDescription',

  invalidSsn: 'constantsVerifyBorrowerInvalidSsn',

  tooManyAttempts: 'constantsVerifyBorrowerTooManyAttempts',
} as const;

export function buildEmailNotificationMessage(email: string): string {
  return `${EMAIL_NOTIFICATION_CONSENT.emailSentPreText}${email}${EMAIL_NOTIFICATION_CONSENT.emailSentPostText}`;
}
